import axios from 'axios';
import { apiPath } from '../../config/apiBase';

const API = apiPath('/api');

function authHeaders(extra = {}) {
  const token = localStorage.getItem('token');
  return { withCredentials: true, headers: { Authorization: `Bearer ${token}`, ...extra } };
}

export const listPayrollStaff = (q) =>
  axios.get(`${API}/payroll/staff`, { ...authHeaders(), params: q ? { q } : {} }).then((r) => r.data);

export const getPayrollStaff = (userId) =>
  axios.get(`${API}/payroll/staff/${userId}`, authHeaders()).then((r) => r.data);

export const updatePayrollStaff = (userId, payload) =>
  axios.put(`${API}/payroll/staff/${userId}`, payload, authHeaders()).then((r) => r.data);

export async function downloadPayrollTemplate() {
  const res = await axios.get(`${API}/payroll/template`, {
    ...authHeaders(),
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'payroll_ctc_template.xlsx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function importPayrollFile(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(
    `${API}/payroll/import`,
    fd,
    authHeaders({ 'Content-Type': 'multipart/form-data' }),
  );
  return res.data;
}

export const listEconomicsProducts = () =>
  axios.get(`${API}/payroll/economics/products`, authHeaders()).then((r) => r.data);

export const listEconomicsClients = (productId) =>
  axios.get(`${API}/payroll/economics/products/${encodeURIComponent(productId)}/clients`, authHeaders()).then((r) => r.data);

export const updateClientEconomics = (clientId, payload) =>
  axios.patch(`${API}/payroll/economics/clients/${encodeURIComponent(clientId)}`, payload, authHeaders()).then((r) => r.data);

export async function downloadClientEconomicsTemplate() {
  const res = await axios.get(`${API}/payroll/economics/template`, {
    ...authHeaders(),
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'client_economics_template.xlsx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function importClientEconomicsFile(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(
    `${API}/payroll/economics/import`,
    fd,
    authHeaders({ 'Content-Type': 'multipart/form-data' }),
  );
  return res.data;
}
